import {
  Button,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from "@mui/material";
import { lazy, useState } from "react";
import PropTypes from "prop-types";

import classes from "./editLaskutus.module.css";
import { useUserData } from "src/context/userContext";

import StepButtons from "src/components/buttons/StepButtons/StepButtons";
import MyDivider from "src/components/layout/MyDivider";
import HelperIcon from "src/components/icons/purposed/HelperIcon/HelperIcon";
import MySwitch from "src/components/MySwitch/MySwitch";
import { EditIcon } from "../icons/ActionIcons";
import LazyLoader from "../layout/Progress/LazyLoader";

// lazy
const ToimittajaSelectorForTyomaaModal = lazy(() =>
  import("../toimittaja/ToimittajaSelectorForTyomaa/ToimittajaSelectorForTyomaaModal")
);

const styles = {
  pad: {
    padding: "5px",
    whiteSpace: "nowrap",
  },
};
export default function EditLaskutus(props) {
  const keikkaData = props.keikkaData;
  const betoniToimittajaNimi = keikkaData.betoniToimittaja.asiakasNimi;
  const pumppuToimittajaNimi = keikkaData.pumppuToimittaja.asiakasNimi;
  const asiakasNimi = keikkaData.asiakas.asiakasNimi;
  const { token, socket, user } = useUserData();
  const [toimittajaSelectorIsOpen, setToimittajaSelectorIsOpen] = useState(false);
  const [isBetoniChecked, setIsBetoniChecked] = useState(keikkaData.laskutus.isBetoniSuoraLaskutus);
  const [isPumppuChecked, setIsPumppuChecked] = useState(keikkaData.laskutus.isPumppuSuoraLaskutus);

  const [origBetoniToimittaja, setOrigBetoniToimittaja] = useState({
    ...keikkaData.betoniToimittaja,
  });
  const [origPumppuToimittaja, setOrigPumppuToimittaja] = useState({
    ...keikkaData.pumppuToimittaja,
  });
  const [origLaskutus, setOrigLaskutus] = useState({ ...keikkaData.laskutus });

  const handleCancelKlik = () => props.closeModal();

  const handleAcceptKlik = async () => {
    keikkaData.laskutus.isBetoniSuoraLaskutus = isBetoniChecked;
    keikkaData.laskutus.isPumppuSuoraLaskutus = isPumppuChecked;
    props.setKeikkaData(keikkaData);
    props.closeModal();

    if (
      origLaskutus.isBetoniSuoraLaskutus !== isBetoniChecked ||
      origLaskutus.isPumppuSuoraLaskutus !== isPumppuChecked
    ) {
      setOrigLaskutus({ ...keikkaData.laskutus });
      await keikkaData.laskutus.saveLaskutusToDB(
        keikkaData.keikkaId,
        token,
        socket,
        keikkaData.varmenne
      );
    }

    if (origPumppuToimittaja.asiakasId !== keikkaData.pumppuToimittaja.asiakasId) {
      setOrigPumppuToimittaja({ ...keikkaData.pumppuToimittaja });
      await keikkaData.handleChange.savePumppuToimittajaToDB(
        keikkaData.keikkaId,
        keikkaData.pumppuToimittaja.asiakasId,
        0,
        0,
        0,
        token,
        socket
      );
    }
    if (origBetoniToimittaja.asiakasId !== keikkaData.betoniToimittaja.asiakasId) {
      setOrigBetoniToimittaja({ ...keikkaData.betoniToimittaja });
      await keikkaData.handleChange.saveBetoniToimittajaToDB(
        keikkaData.keikkaId,
        keikkaData.betoniToimittaja.asiakasId,
        0,
        0,
        0,
        token,
        socket,
        user.personId
      );
    }
  };
  const handleClose = () => props.closeModal();
  const handleBetoniChange = (checked) => setIsBetoniChecked(checked);
  const handlePumppuChange = (checked) => setIsPumppuChecked(checked);

  const ToimittajaEditIcon = <EditIcon fontSize="small" style={{ opacity: 0.6 }} />;
  return (
    <>
      <LazyLoader>
        <ToimittajaSelectorForTyomaaModal
          isOpen={toimittajaSelectorIsOpen}
          onClose={() => setToimittajaSelectorIsOpen(false)}
          doFindClosestSijaintiForKeikka={false}
        />
      </LazyLoader>
      <Dialog open={props.open} onClose={handleClose}>
        <DialogTitle id="alert-dialog-title">Laskutusketjut</DialogTitle>
        <DialogContent>
          {keikkaData.modules.hasBetoni && (
            <>
              <DialogContentText id="alert-dialog-description"></DialogContentText>
              <MyDivider gutterBottom />
              <div className="spaceBetween">
                <Typography align="center" variant="h6" className={classes.otsikko} color="primary">
                  Betonin laskutus
                </Typography>
                <HelperIcon helpId="betonilaskutusketju" />
              </div>
              <div className={classes.rivi}>
                <Typography variant="h7" color="primary" sx={styles.pad}>
                  Betonin valmistaja
                </Typography>
                <Button
                  sx={styles.margin0}
                  onClick={() => setToimittajaSelectorIsOpen(true)}
                  aria-label="Valitse betonitoimittaja">
                  {keikkaData.betoniToimittaja.asiakasNimi}
                  {ToimittajaEditIcon}
                </Button>
                <Typography variant="h7" color="primary" sx={styles.pad}>
                  laskuttaa
                </Typography>
              </div>
              <MySwitch
                checked={isBetoniChecked}
                rightSide={"asiakasta " + asiakasNimi}
                leftSide={"yritystä " + pumppuToimittajaNimi}
                disabled={!(keikkaData.tyomaa.auth.edit && keikkaData.auth.edit)}
                onChange={handleBetoniChange}
              />
            </>
          )}
          {keikkaData.modules.hasPumppu && (
            <>
              <MyDivider gutter />
              <div className="spaceBetween">
                <Typography align="center" variant="h6" className={classes.otsikko} color="primary">
                  Pumppauksen laskutus
                </Typography>
                <HelperIcon helpId="pumppulaskutusketju" />
              </div>
              <div className={classes.rivi}>
                <Typography color="primary" sx={styles.pad}>
                  Pumpputoimittaja
                </Typography>
                <Button
                  sx={styles.margin0}
                  onClick={() => setToimittajaSelectorIsOpen(true)}
                  aria-label="Valitse betonitoimittaja">
                  {keikkaData.pumppuToimittaja.asiakasNimi}
                  {ToimittajaEditIcon}
                </Button>
                <Typography color="primary" sx={styles.pad}>
                  laskuttaa
                </Typography>
              </div>
              <MySwitch
                checked={isPumppuChecked}
                rightSide={"asiakasta " + asiakasNimi}
                leftSide={"yritystä " + betoniToimittajaNimi}
                disabled={!(keikkaData.tyomaa.auth.edit && keikkaData.auth.edit)}
                onChange={handlePumppuChange}
              />
            </>
          )}
        </DialogContent>
        <StepButtons
          withPadding
          onCancelKlik={() => handleCancelKlik()}
          onSaveKlik={() => handleAcceptKlik(keikkaData)}
        />
      </Dialog>
    </>
  );
}

EditLaskutus.propTypes = {
  open: PropTypes.bool,
  closeModal: PropTypes.func,
  keikkaData: PropTypes.object,
  setKeikkaData: PropTypes.func,
};
